/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import _, { filter, find } from 'lodash';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const blueColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#347dc6"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;
export const deselectedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g id="Checkbox" fill="#fff" stroke="#aaafb9" stroke-width="1">
  <rect width="20" height="20" rx="6" stroke="none"/>
  <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="none"/>
</g>
</svg>`;

const uncheckedMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHZSURBVEhL7ZZZbwIxDIT7//8bAiHEJcSNuO/7dPVZbFWBkwaC4KXzMsRJllln7OyXfBimgOPxKJvNRvl8Pstut5P9fq9zMGPioet8MAVMp1MpFovK2+1WarWadLtdnYMZEw9d54MpYLFYSLVaVeYt2u22DAYDnYMZE/9rXb1el36/L6vVSmMWTAGXy0VOp5Ny8jtJJXw751q3XC6lUChIo9HQmAVTAIpbrZZXeQgOh4MMh0OZzWbXyD1MAePxWLLZrHIMyAJmxKQumALYNJ/Pfxz9LDAg6e/1etfIPUwBGApnwzFgf7PZVCO6YAoYjUaSyWSUY4AxST/mdMEUsF6vpdPpKMcAE1KOZNMFUwDmYXNSUs+CLlkqlfQYXDAFYMBKpaIcA1LPM3yZNAVQt+Vy2Vu/IUAAzYhMuGAKYCMO9pknBPwxL0JTc8FpQi6TWBPSR+gBk8nkGrmHKYDyS6fTLylDsugzsymA9NOGX9GIft+QFkwBlCBXLByD228EC6YAziyXy3nPLgSkniz47hRTAKXDJUI35CjIBI6mp8OMiSd9Ag5ZZ8EUkIAvmnw+r9XAvZ5KpZQZE2f+kXUWvALwAcfAhcJ58lCYMXHmH1lnwSvgHfgX8GEBIt8EVEx6Cv/eTAAAAABJRU5ErkJggg==';
export const checkMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAYAAADwbH0HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAQDSURBVEhL7VZJKK5tGH5TEmVYSCRlCCVSQhFFsZCFjUSRUBaGLLBQ2EgpiaysKDIlGYsdsqCMSabM8zzP0/V33f/3nl5fzve9p87pLP7/qrf7Ge7nuZ/nHq7nVfCX8L/h34bz83Nsb2/Lx7Yx/pjhubk59PX1yce2MX6b4dfXV7nZzMwM2tvbUVJSgry8PDQ2Nn5v+O3tDY+Pj6D8+PjA8/MzXl5eZJKSfY6b0nt6esLBwQHGx8dRX1+P1NRUxMXFISkpCc3NzVheXhY9LZSrqyusrKyAkhtsbW3h6OhIJinZ57gpvbW1NXR2diIzMxMxMTGIiIhAeXk5hoaGsLm5ibu7O9HTQrm9vZVJSt5if38fp6enMknJPse/06Pxvb09uVV2djaCg4MRFRWFnJwcDAwMyHrVK8ZQPj8/8f7+Dkq1TVcSlMZz2jYNDw4OiktdXV3h5+eH/Px8ifPJyYmsp+53UO7v7+XUlHpBV6+vr6OlpQUpKSkIDQ1FSEgIioqK0NvbK0lGHVNQLi4usLCwAEo94E0Z2+7ubmRlZcHBwQGBgYHIyMjA8PCwJJkeKIzBzc3NT2NhDB5wdHRUMjcgIAAuLi4oKChAT08PJiYmsLOzY9A0DYWJwkylVPHw8IDDw0MxwhDwliq4eUVFBXx9feHl5YX4+Hi0tbWJwY2NDYmtHiiMx/z8/Bda293dlVKYnp6WDbXxqq6uRlBQEGxtbREdHS0ZzTJjfZNEtIc0BYW3Y1wor6+vMTY2hpqaGiQnJwvz1NXVYXFxUb7+/n4kJibCzc1N3FxYWCjkQI/RKMuHbT1QmPJcRMnarK2tFdaxtraGo6MjIiMjhRyampokrt7e3nB2dpZ2V1eXYRsIq62uroq39EBhYrE0KLmYbmtoaEBsbCw8PDzg6ekpyZOeng53d3cxGhYWJofRGqGLuQc9pwcK3UvKo1QxOzuLyspKYSI7OzuEh4fD398fiqIISeTm5soaLWiY1MjD64HCBcxobVIcHx9jcnISCQkJsLCwgI2NDaysrMRwWlqalM7Z2ZlB+1/QIA9DMtIDSS4SgtZF3IRlwaeNMWW8LS0tJZPpCYbGmJnIAzzw5eWlYcQ0pJz4XmrLSUVra6tksZOTE+zt7eHj44OOjg7D7Feo/K3yvDkIgZAotASiYmRkBGVlZcLFfO5KS0sxNTVlmP0Krte+bOagsJT41FEagzFjPIuLi1FVVSUPvfoGG8P4jTYHhTEhOXwXG25Gb5C9SDIsl+8OSNDFvLVezldYAurGNMKN1eSiZJ/jNEpQ6tEzhx8/e/wNXVpakuxmqfAxp2Sf45z/FT1z+GGYcaa7SfZ0MTejZJ/jnP8VPXP4Y//V5vBfMwz8A98pV66XXgmUAAAAAElFTkSuQmCC';

const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];
const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};

const amountFormatter = (value = 0) => {
  if (value < 0) {
    return `($${value
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      .substring(2)})`;
  }
  return parseFloat(value)?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

const numberFormatter = (value = 0) => {
  if (value < 0) {
    return `(${parseFloat(value)?.toLocaleString('en-US').substring(1)})`;
  }
  return parseFloat(value)?.toLocaleString('en-US');
};
const getHeader = (currentPage, pageCount, data, options) => {
  const { prinDate, requestedBy, reportName } = data;

  const { pageSize, info } = options;
  const {
    firstInfo = '',
    secondInfo = '',
    thirdInfo = '',
    fourthInfo = '',
    fifthInfo = '',
  } = info;

  let widths = [255, 245, 245];
  if (pageSize && pageSize.width) {
    const w = (pageSize.width - 95) / 3;
    widths = [w, w, w];
  }
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [42, 20, 28.8, 40],
    style: 'tableExample',
    table: {
      widths: widths,
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: firstInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            bold: true,
          },
          {
            text: thirdInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: secondInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
            bold: true,
          },
          {
            text: fourthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: fifthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
            bold: true,
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};
let descriTest = '';
const getTableBodyData = (data, cols, descr = {}) => {
  descriTest = descr?.shortDescription;
  const dataToReturn = [];
  const totaRecordCount = 0;

  const columns = [];
  for (let i = 0; i < cols.length; i += 1) {
    columns.push({
      text: cols[i].headerName,
      fontSize: contentFont,
      border: [true, true, true, true],
      bold: true,
      alignment: cols[i].alignment || 'left',
    });
  }
  dataToReturn.push(columns);
  for (let i = 0; i < data?.length; i += 1) {
    const tempCols = [];

    for (let j = 0; j < cols.length; j += 1) {
      let text = data[i][cols[j].field];
      const boolValue = data[i]?.bold || false;
      if (cols[j].isAmount || cols[j].exportZeroesTwo) {
        text = amountFormatter(data[i][cols[j].field] || '0.00');
      } else if (cols[j]?.isCount) {
        text = numberFormatter(data[i][cols[j].field] || 0);
      }
      if (
        text?.toString() === '0.00' &&
        cols[j].printPrefixValue?.trim() === '$'
      ) {
        text = '$ 0.00';
      }

      if (cols[j].checkbox && (text || text === 0)) {
        tempCols.push({
          alignment: cols[j].alignment || 'left',
          border: [true, boolValue, true, true],
          width: 15,
          marginTop: -1,

          svg: text === 1 ? blueColorWithSelectedIcon : deselectedIcon,
        });
      } else {
        tempCols.push({
          text,
          fontSize: boolValue ? contentFont : contentFont - 1,
          border: [true, boolValue, true, true],
          bold: boolValue,
          alignment: cols[j].alignment || 'left',
          color:
            typeof parseFloat(data[i][cols[j].field]) === 'number' &&
            data[i][cols[j].field] < 0
              ? 'red'
              : 'black',
        });
      }
    }
    dataToReturn.push(tempCols);
  }
  return dataToReturn;
};
const getTableBody = (
  data,
  cols,
  paginationArr,
  colWidths,
  options,
  optDisputeCode = {},
  header
) => {
  const body = [];
  const { titleName = '', mapping = {}, title = '', map = {} } = options;
  const dataKeys = paginationArr.length > 0 ? paginationArr : Object.keys(data);
  const widths = cols?.map((x) => '*');
  for (let i = 0; i < dataKeys.length; i += 1) {
    const descr = find(optDisputeCode, (o) => {
      return o.codeValuetemp == dataKeys[i];
    });
    !(header?.reportName === 'Top Balances Report') &&
      body.push({
        text: [
          {
            text: 'Description:',
            bold: true,
            fontSize: contentFont,
          },
          {
            text: descr?.shortDescription ? descr?.shortDescription : '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
        ],
      });

    body.push({
      text: [
        {
          text: titleName || 'Rebate Program Cd: ',
          bold: true,
          fontSize: contentFont,
        },
        { text: mapping[dataKeys[i]] || dataKeys[i], fontSize: contentFont },
      ],
    });

    header?.reportName === 'Top Balances Report' &&
      body.push({
        text: [
          {
            text: title || '',
            bold: true,
            fontSize: contentFont,
          },
          { text: map[dataKeys[i]] || dataKeys[i], fontSize: contentFont },
        ],
      });

    body.push({
      style: 'tableExample',
      table: {
        widths: ['*'],
        body: [
          [
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: widths,
                body: getTableBodyData(
                  data[dataKeys[i]],
                  cols,
                  paginationArr,
                  widths
                ),
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });

    if (i < dataKeys.length - 1)
      body.push({
        text: '',
        fontSize: 14,
        bold: true,
        pageBreak: 'before',
        margin: [0, 0, 0, 8],
      });
  }
  return body;
};
const getTableBodyTopBalance = (
  data,
  cols,
  paginationArr,
  colWidths,
  options,
  optDisputeCode = {},
  header
) => {
  const body = [];
  const { titleName = '', mapping = {}, title = '', map = {} } = options;
  const dataKeys = paginationArr.length > 0 ? paginationArr : Object.keys(data);
  const widths = cols?.map((x) => '*');
  for (let i = 0; i < dataKeys.length; i += 1) {
    const descr = find(optDisputeCode, (o) => {
      return o.codeValuetemp == dataKeys[i];
    });
    !(header?.reportName === 'Top Balances Report') &&
      body.push({
        text: [
          {
            text: 'Description:',
            bold: true,
            fontSize: contentFont,
          },
          {
            text: descr?.shortDescription ? descr?.shortDescription : '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
        ],
      });

    body.push({
      text: [
        {
          text: titleName || 'Rebate Program Cd: ',
          bold: true,
          fontSize: contentFont,
        },
        { text: mapping[dataKeys[i]] || dataKeys[i], fontSize: contentFont },
      ],
    });

    // header?.reportName === 'Top Balances Report' &&
      body.push({
        text: [
          {
            text: title || '',
            bold: true,
            fontSize: contentFont,
          },
          { text: map[dataKeys[i]] || dataKeys[i], fontSize: contentFont },
        ],
      });

    body.push({
      style: 'tableExample',
      table: {
        widths: ['*'],
        body: [
          [
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: widths,
                body: getTableBodyData(
                  data[dataKeys[i]],
                  cols,
                  paginationArr,
                  widths
                ),
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });

    if (i < dataKeys.length - 1)
      body.push({
        text: '',
        fontSize: 14,
        bold: true,
        pageBreak: 'before',
        margin: [0, 0, 0, 8],
      });
  }
  return body;
};

/**
 * Download as PDF with all Data.
 * @param {object} headerData - conatisn header info of PDF.
 * @param {object} bodyData - constains Body data for PDF.
 */
const getPdfData = (
  bodyData,
  columns,
  headerData,
  paginationArr,
  widths,
  options,
  header = {},
  optDisputeCode = []
) => {
  const { pageSize } = options;

  const content = getTableBody(
    bodyData,
    columns,
    paginationArr,
    widths,
    options,
    optDisputeCode,
    header
  );
  const currentYear = new Date().getFullYear();
  let docDefinition = {
    header: (currentPage, pageCount) => {
      let newOpt = _.cloneDeep(options);

      if (
        !_.isEmpty(optDisputeCode) &&
        header?.reportName === 'Dispute Code Report'
      ) {
        let descriptions = [];
        let currentPageCode = '';

        const currentDisputeCodeObjs = Object.keys(bodyData).map((key) => {
          const codeObj = optDisputeCode.find(
            (code) => code.codeValuetemp === key
          );
          return codeObj || null;
        });

        currentDisputeCodeObjs.forEach((currentDisputeCodeObj, index) => {
          if (currentDisputeCodeObj) {
            descriptions[
              index
            ] = `Description: ${currentDisputeCodeObj.shortDescription}`;
          }
        });

        let cumulativeLength = 0;
        for (const key in bodyData) {
          if (bodyData.hasOwnProperty(key)) {
            const currentArray = bodyData[key];
            const arrayLength = currentArray.length;

            // Check if currentPage falls within the current array's range
            if (currentPage <= cumulativeLength + arrayLength) {
              currentPageCode = key;
              break;
            }

            cumulativeLength += arrayLength;
          }
        }

        const currentPageIndex = currentPage - cumulativeLength - 1;
        const currentPageArray = bodyData[currentPageCode];

        if (currentPageCode && currentPageArray && currentPageIndex >= 0) {
          const currentDescriptionIndex =
            Object.keys(bodyData).indexOf(currentPageCode);
          const description = descriptions[currentDescriptionIndex];

          descriptions = descriptions.map((desc, index) =>
            index === currentDescriptionIndex ? desc : ''
          );

          currentPageCode = currentPageCode;
          newOpt = {
            ...newOpt,
            info: {
              ...options.info,
              // fourthInfo: description || options.info.fourthInfo,
            },
          };
        }
      }
  
      const displayPageCount = (options && options.totalPages) || pageCount;
     
      const displayCurrentPage =
        options && options.totalPages
          ? Math.min(currentPage, options.totalPages)
          : currentPage;
      return getHeader(displayCurrentPage, displayPageCount, headerData, newOpt);
    },
     footer: (currentPage, pageCount) => {
      const footers = [];

      if (
        options.footerVariableObj &&
        options.showFooter &&
        currentPage === pageCount
      ) {
        footers.push({
          text: `${options.footerVariableObj.name}: $${options.footerVariableObj.amount}`,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'right',
          marginRight: [25.92],
        });
      }

      footers.push({
        text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
        fontSize: 8,
        color: '#636363',
        fontFamily: 'Arial',
        alignment: 'center',
      });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };

  if (pageSize && pageSize?.width && pageSize.height) {
    docDefinition = {
      ...docDefinition,
      pageSize: {
        width: pageSize.width,
        height: pageSize.height,
      },
    };
  }
  return docDefinition;
};
const getPdfDataTopBalance = (
  bodyData,
  columns,
  headerData,
  paginationArr,
  widths,
  options,
  header = {},
  optDisputeCode = []
) => {
  const { pageSize } = options;

  const content = getTableBodyTopBalance(
    bodyData,
    columns,
    paginationArr,
    widths,
    options,
    optDisputeCode,
    header
  );
  const currentYear = new Date().getFullYear();
  let docDefinition = {
    header: (currentPage, pageCount) => {
      let newOpt = _.cloneDeep(options);

      if (
        !_.isEmpty(optDisputeCode) &&
        header?.reportName === 'Dispute Code Report'
      ) {
        let descriptions = [];
        let currentPageCode = '';

        const currentDisputeCodeObjs = Object.keys(bodyData).map((key) => {
          const codeObj = optDisputeCode.find(
            (code) => code.codeValuetemp === key
          );
          return codeObj || null;
        });

        currentDisputeCodeObjs.forEach((currentDisputeCodeObj, index) => {
          if (currentDisputeCodeObj) {
            descriptions[
              index
            ] = `Description: ${currentDisputeCodeObj.shortDescription}`;
          }
        });

        let cumulativeLength = 0;
        for (const key in bodyData) {
          if (bodyData.hasOwnProperty(key)) {
            const currentArray = bodyData[key];
            const arrayLength = currentArray.length;

            // Check if currentPage falls within the current array's range
            if (currentPage <= cumulativeLength + arrayLength) {
              currentPageCode = key;
              break;
            }

            cumulativeLength += arrayLength;
          }
        }

        const currentPageIndex = currentPage - cumulativeLength - 1;
        const currentPageArray = bodyData[currentPageCode];

        if (currentPageCode && currentPageArray && currentPageIndex >= 0) {
          const currentDescriptionIndex =
            Object.keys(bodyData).indexOf(currentPageCode);
          const description = descriptions[currentDescriptionIndex];

          descriptions = descriptions.map((desc, index) =>
            index === currentDescriptionIndex ? desc : ''
          );

          currentPageCode = currentPageCode;
          newOpt = {
            ...newOpt,
            info: {
              ...options.info,
              // fourthInfo: description || options.info.fourthInfo,
            },
          };
        }
      }
  
      const displayPageCount = (options && options.totalPages) || pageCount;
     
      const displayCurrentPage =
        options && options.totalPages
          ? Math.min(currentPage, options.totalPages)
          : currentPage;
      return getHeader(displayCurrentPage, displayPageCount, headerData, newOpt);
    },
     footer: (currentPage, pageCount) => {
      const footers = [];

      if (
        options.footerVariableObj &&
        options.showFooter &&
        currentPage === pageCount
      ) {
        footers.push({
          text: `${options.footerVariableObj.name}: $${options.footerVariableObj.amount}`,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'right',
          marginRight: [25.92],
        });
      }

      footers.push({
        text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
        fontSize: 8,
        color: '#636363',
        fontFamily: 'Arial',
        alignment: 'center',
      });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };

  if (pageSize && pageSize?.width && pageSize.height) {
    docDefinition = {
      ...docDefinition,
      pageSize: {
        width: pageSize.width,
        height: pageSize.height,
      },
    };
  }
  return docDefinition;
};
/**
 * Download as PDF with all Data.
 * @param {object} data - header info of PDF.
 * @param {object} userDefaultValues - use info containg object
 */
const getHeaderData = (data, UserDefaultsValues, logInUser) => {
  const { reportName } = data;
  return {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultsValues && UserDefaultsValues.userId
        ? UserDefaultsValues.userId
        : logInUser,
    reportName,
  };
};

/**
 * Download as PDF with all Data.
 * @param {object} header - header info of PDF.
 * @param {object} bodyData - All the data for the PDF.
 * @param {object} userDefaultValues
 */
export const exportAllPDF = (
  header,
  bodyData,
  columnApi,
  userDefaultValues,
  options = {},
  paginationArr = [],
  widths,
  logInUser,
  optDisputeCode = []
) => {
  const colDisplayArray = [];
  if (columnApi) {
    columnApi.getAllDisplayedColumns().forEach((prop) => {
      if (
        !prop?.colDef?.removeColumn &&
        !prop?.colDef?.pdfExportOptions?.skipColumn
      ) {
        colDisplayArray.push({ ...prop, ...prop.colDef });
      }
    });
  }
  const headerData = getHeaderData(header, userDefaultValues, logInUser);
  const pdfData = getPdfData(
    bodyData,
    colDisplayArray,
    headerData,
    paginationArr,
    widths,
    options,
    header,
    optDisputeCode
  );
  pdfMake
    .createPdf(pdfData)
    .download(`${header?.fileName || header?.reportName || 'data'}.pdf`);
};
export const exportAllPDFTopBalance = (
  header,
  bodyData,
  columnApi,
  userDefaultValues,
  options = {},
  paginationArr = [],
  widths,
  logInUser,
  optDisputeCode = []
) => {
  const colDisplayArray = [];
  if (columnApi) {
    columnApi.getAllDisplayedColumns().forEach((prop) => {
      if (
        !prop?.colDef?.removeColumn &&
        !prop?.colDef?.pdfExportOptions?.skipColumn
      ) {
        colDisplayArray.push({ ...prop, ...prop.colDef });
      }
    });
  }
  const headerData = getHeaderData(header, userDefaultValues, logInUser);
  const pdfData = getPdfDataTopBalance(
    bodyData,
    colDisplayArray,
    headerData,
    paginationArr,
    widths,
    options,
    header,
    optDisputeCode
  );
  pdfMake
    .createPdf(pdfData)
    .download(`${header?.fileName || header?.reportName || 'data'}.pdf`);
};
